import { Component, OnDestroy, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import * as moment from 'moment-timezone';
import { animate, style, transition, trigger } from "@angular/animations";
import { MenuService, UserRoles } from '../menu-service/menu.service';
import { Events } from "src/app/utils/event-utils";
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { sweetAlert } from 'src/app/utils/swal';
import { PushToTalkService } from 'src/app/component/push-to-talk/push-to-talk-service/push-to-talk.service';
import { urls } from 'src/app/utils/url-utils';
import { CompaniesService } from 'src/app/component/companies/service/companies.service';
import { StaffAttendanceComponent } from 'src/app/component/staffs/staff-attendance/staff-attendance.component';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger("openCloseProfile", [
      transition(":enter", [
        style({ opacity: 0, transform: "scale(0.95)" }), //apply default styles before animation starts
        animate(
          "500ms ease-in-out",
          style({ opacity: 1, transform: "scale(1)" })
        )
      ]),
      transition(":leave", [
        style({ opacity: 1, }), //apply default styles before animation starts
        animate(
          "300ms ease-in-out",
          style({ opacity: 0, transform: "scale(.95)" })
        )
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('audioOption', { static: true }) audioPlayerRef: ElementRef;
  @ViewChild('messageTone', { static: true }) messageTone: ElementRef;
  @ViewChild('pttTone', { static: true }) pttTone: ElementRef;
  @ViewChild('callTone', { static: true }) callTone: ElementRef;
  @ViewChild(StaffAttendanceComponent, { static: false }) staffAttendance: StaffAttendanceComponent;
  subMenus;
  showUserOptions = false;
  showNotifications = false;
  showMessageNotifications = false;
  currentPath = '';
  isHome = false;
  timeZone;
  showQuickMenu = false;
  user: any;
  intervalTimeID: any;
  currentTime = moment().toISOString();
  menus;
  isSound = true;
  userRole;
  notificationsCount = 0;
  messageCount = 0;
  dateObj = {};
  now;
  messageDetail = [];
  callModalObj;
  showCallNotification = false;
  showCallModal = false;
  tempCall;
  notificationsMuted: boolean = false;
  logoutURL: any;
  canView: boolean = false;
  isFullscreen: boolean = false;
  profileCompanies: any[] = [];
  switchingProfileId: string = null;
  deletingAccountLinkId: string = null;
  showAddCompanyModal: boolean = false;

  get currentTimeZone(): string {
    return this.timeZone || (this.user && this.user.timeZone) || (this.user && this.user.company && this.user.company.timeZone) || moment.tz.guess();
  }

  isAllowStaffShift = true;

  constructor(
    private sharedDataService: SharedDataService,
    private authService: AuthService,
    private menuService: MenuService,
    private socket: SocketService,
    private router: Router,
    private socketService: SocketService,
    private dispatchCenterService: DispatchCenterService,
    private toastr: ToastrService,
    private pushToTalk: PushToTalkService,
    private cdr: ChangeDetectorRef,
    private companiesService: CompaniesService
  ) {

    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement;
      this.cdr.detectChanges();
    });

    document.addEventListener('keyup', e => {
      console.log(e);
      // e.ctrlKey &&
      if (e.altKey && (e.key.toLowerCase() === 'v' || e.key.toLowerCase() === '√')) {
        this.canView = !this.canView;
      }
    });

  }

  ngOnInit() {
    this.setUpDriverAlertSocketListener();

    this.now = moment().format('L');

    if (localStorage.getItem('currentDate')) {
      const obj = JSON.parse(localStorage.getItem('currentDate'));
      const storedDate = Object.keys(obj)[0];
      if (this.now === storedDate) {
        if (localStorage.getItem('notificationsCount')) {
          this.notificationsCount = JSON.parse(localStorage.getItem('notificationsCount'));
          window.addEventListener('storage', this.storageListener);
        }
      } else {
        this.dateObj[this.now] = 0;
        localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
        localStorage.removeItem('notificationsCount');
      }
    } else {
      this.dateObj[this.now] = 0;
      localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
    }

    this.getUser();
    this.router.events
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.url) {
            let path = event.url;
            this.currentPath = path.substring(1);
            this.getSubMenus();
          }
        }
      });
    this.getSubMenus();

    this.intervalTimeID = setInterval(() => {
      this.currentTime = moment().tz(this.currentTimeZone).toISOString();
    }, 1000);

    this.socketService.addListener(Events.SEND_EXPIRE_DISPATCH)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.sucess) {
          this.onAudioPlay();
          this.getNotificationsList();

        }
      });

    if (localStorage.getItem("sound")) {
      this.isSound = JSON.parse(localStorage.getItem("sound"));
    }
    if (localStorage.getItem("notificationsMuted")) {
      this.notificationsMuted = JSON.parse(localStorage.getItem("notificationsMuted"));
    }

    this.initMultiProfileSync();

  }

  private accountSyncChannel: any = null;

  initMultiProfileSync() {
    if (typeof BroadcastChannel !== 'undefined') {
      try {
        this.accountSyncChannel = new BroadcastChannel('nemt_profile_sync');
        this.accountSyncChannel.onmessage = (event: MessageEvent) => {
          this.handleSyncMessage(event.data);
        };
      } catch (e) {
        console.warn('BroadcastChannel error', e);
      }
    }
    window.addEventListener('storage', this.storageListener);
  }

  handleSyncMessage(data: any) {
    if (!data) return;
    if (data.type === 'ACCOUNT_SWITCHED') {
      window.location.reload();
    } else if (data.type === 'ACCOUNT_LINKS_UPDATED') {
      this.buildProfileCompanies();
    } else if (data.type === 'ACCOUNT_LOGOUT') {
      this.logout(true);
    }
  }

  broadcastSyncEvent(type: string, payload?: any) {
    const syncTime = moment().valueOf();
    const data = { type, timestamp: syncTime, ...payload };
    if (this.accountSyncChannel) {
      try {
        this.accountSyncChannel.postMessage(data);
      } catch (e) {
        console.error('Error posting to BroadcastChannel', e);
      }
    }
    try {
      if (type === 'ACCOUNT_SWITCHED') {
        localStorage.setItem('nemt_account_switched', syncTime.toString());
      } else if (type === 'ACCOUNT_LINKS_UPDATED') {
        localStorage.setItem('nemt_account_links_updated', syncTime.toString());
      } else if (type === 'ACCOUNT_LOGOUT') {
        localStorage.setItem('nemt_account_logout', syncTime.toString());
      }
    } catch (e) {
      console.error('Error setting storage sync key', e);
    }
  }

  storageListener = (event: StorageEvent) => {
    if (!event) return;
    if (event.key === 'sound' && event.newValue) {
      this.isSound = JSON.parse(event.newValue);
    }
    if (event.key === 'notificationsMuted' && event.newValue) {
      this.notificationsMuted = JSON.parse(event.newValue);
    }
    if (event.key === 'nemt_account_logout') {
      this.logout(true);
    } else if (event.key === 'token') {
      if (!event.newValue) {
        this.logout(true);
      } else {
        window.location.reload();
      }
    } else if (event.key === 'nemt_account_switched') {
      window.location.reload();
    }
    if (event.key === 'nemt_account_links_updated') {
      this.buildProfileCompanies();
    }
  }

  getNotificationsList() {
    this.dispatchCenterService
      .getNotifications()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {

        if (data) {
          this.notificationsCount++;
          localStorage.setItem('notificationsCount', JSON.stringify(this.notificationsCount))
          // localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
          if (this.menus && (this.menus.dashboard || this.menus.operations || this.menus.trips || this.menus.manifest)) {
            const notifications = data[0];
            if (!this.notificationsMuted) {
              this.toastr.success(notifications.text, 'Alert');
            }
          }
        }
      });
  }

  setUpDriverAlertSocketListener() {
    this.socketService.addListener(Events.RECEIVE_DRIVER_ALERT_MESSAGE_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log("data check", data)
        if (data.success) {
          this.messageCount++;
          localStorage.setItem('messageCount', JSON.stringify(this.messageCount))
          // localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
          if (this.menus && (this.menus.dashboard || this.menus.operations || this.menus.trips || this.menus.manifest)) {
            const notifications = data;
            this.messageDetail.push(data);
            this.toastr.success(notifications.message + " By " + notifications.driverAlert.sender.displayName, 'Alert');
            this.onMessagePlay();

          }
        }
      });


    this.socketService.addListener(Events.PUSH_TO_TALK)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log("data check", data)
        let isStaff = this.user && this.user.sId ? true : false;
        if (isStaff && data.type === 'cnew') {
          return; // ignore cmessage if received for the company.
        }
        this.toastr.success("Voice message" + " by " + data.pushtotalkmessage.sender.displayName, 'Alert');
        this.playAudio(data.pushtotalkmessage.fileURL);
        this.onPttPlay();
        this.markAsReadMessage(data.pushtotalkmessage._id);
      });


    this.socketService.addListener(Events.DRIVER_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log(data);
        if (data) {
          if (data.status === 'join') {
            if (this.callModalObj) {
              return;
            }
            this.callModalObj = data;
            if (this.user._id === this.callModalObj.sender._id) {
              this.onCallTuneStop();
              this.showCallModal = true;
            } else {
              this.showCallNotification = true
              this.onCallTunePlay();
            }
          } else if (data.status === 'accept') {
            if (this.callModalObj && this.callModalObj.roomId === data.roomId) {
              this.showCallNotification = false;
              this.callModalObj = null;
              this.onCallTuneStop();
            }

          } else if (data.status === 'leave') {
            if (this.callModalObj && this.callModalObj.roomId === data.roomId) {
              this.showCallNotification = false;
              this.showCallModal = false;
              this.callModalObj = null;
              this.callTone.nativeElement.pause();
            }
          }
        }
        else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }

      });
  }

  playAudio(audioUrl): void {
    if (audioUrl) {
      const audio = new Audio(audioUrl);
      audio.play();
    }
  }

  onAudioPlay() {
    if (this.isSound) {
      this.audioPlayerRef.nativeElement.play();
    }
  }
  onMessagePlay() {
    if (this.isSound) {
      this.messageTone.nativeElement.play();
    }
  }
  onPttPlay() {
    if (this.isSound) {
      this.pttTone.nativeElement.play();
    }
  }
  onCallTunePlay() {
    if (this.isSound) {
      this.callTone.nativeElement.play();
    }
  }
  onCallTuneStop() {
    if (this.isSound) {
      this.callTone.nativeElement.pause();
    }
  }
  toggleMute() {
    this.notificationsMuted = !this.notificationsMuted;
    localStorage.setItem("notificationsMuted", JSON.stringify(this.notificationsMuted));
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          if (user.hasOwnProperty('logoutURL') && user.logoutURL) {
            this.logoutURL = user.logoutURL;
          }
          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if (this.user.sRoles) {
                if (this.user.hasOwnProperty('isStaffShift') && this.user.hasOwnProperty('isShift')) {
                  this.isAllowStaffShift = this.user.isStaffShift && this.user.isShift;
                }
                this.userRole = this.menuService.getUserRoleTitle(this.user.sRoles);
                this.menus = this.menuService.getMenu(this.user.sRoles, this.user);
              } else {
                this.userRole = this.menuService.getUserRoleTitle(this.user.roles);
                this.menus = this.menuService.getMenu(this.user.roles, this.user);
              }
            } else if ((typeof this.user.roles) === 'object') {
              this.userRole = this.menuService.getUserRoleTitle(this.user.roles[0]);
              this.menus = this.menuService.getMenu(this.user.roles[0], this.user);
            }
          }
          this.buildProfileCompanies();
        }
      });
  }

  getSubMenus() {
    this.sharedDataService
      .getSubMenus()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.subMenus = [];
        if (data) {
          this.isHome = this.currentPath === data.key ? true : false;
          if (data.subMenus) {
            this.subMenus = data.subMenus;
          }
        }
      });
  }

  onQuickMenuClick(menuKey) {
    this.subMenus = [];
    const menu = this.menus[menuKey];
    this.sharedDataService.saveSubMenus(menu ? menu : null);

    // if (menu) {
    //   this.subMenus = menu.subMenus;
    // }
  }

  logout(isRemoteSync = false) {
    if (!isRemoteSync) {
      this.broadcastSyncEvent('ACCOUNT_LOGOUT');
    }
    this.socket.disconnectSocket();
    this.authService.removeToken();
    this.authService.removeAuthToken();
    this.sharedDataService.saveUser(null);
    this.sharedDataService.saveSubMenus(null);
    localStorage.removeItem('notificationsCount');
    localStorage.removeItem('messageCount');
    if (this.logoutURL) {
      window.open(`${this.logoutURL}`, '_self');
    } else {
      this.router.navigateByUrl('login');
    }
  }

  viewSmallScreenMenu() {
    this.sharedDataService.setSmallScreenMenuState(true);
  }

  onClickDropdownMenu() {
    this.sharedDataService.saveSubMenus(null);
    this.showUserOptions = !this.showUserOptions;
    if (this.showUserOptions) {
      this.closeAttendancePopover();
      this.showQuickMenu = false;
    }
  }

  toggleSound() {
    this.isSound = !this.isSound;
    localStorage.setItem("sound", JSON.stringify(this.isSound));
  }

  canViewSubmenu(subMenus, title) {
    let isFound = false;
    if (subMenus && subMenus.length) {
      isFound = subMenus.some(m => m.title === title);
    }
    return isFound;
  }
  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    this.notificationsCount = null;
    localStorage.removeItem('notificationsCount');
    if (this.showNotifications) {
      this.closeAttendancePopover();
    }
  }


  toggleMessageNotifications() {
    this.showMessageNotifications = !this.showMessageNotifications;
    this.messageCount = null;
    localStorage.removeItem('messageCount');
    if (this.showMessageNotifications) {
      this.closeAttendancePopover();
    }
  }

  closeCallNotificationModal(evt: any) {
    console.log("event check", evt);
    this.onCallTuneStop();
    if (evt) {
      this.showCallNotification = false;
      this.showCallModal = true
    } else {
      this.showCallNotification = false;
      this.callModalObj = null;
    }

  }

  markAsReadMessage = (pushtotalkmessageId) => {
    this.pushToTalk.markAsReadMessage({ pushtotalkmessageId }).pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
      if (data) {
      }
    })
  };

  onAttendancePopoverOpened(): void {
    this.showUserOptions = false;
    this.showQuickMenu = false;
    this.showNotifications = false;
    this.showMessageNotifications = false;
  }

  closeAttendancePopover(): void {
    if (this.staffAttendance) {
      this.staffAttendance.closePopover();
    }
  }

  ngOnDestroy(): void {
    if (this.intervalTimeID) {
      clearInterval(this.intervalTimeID);
    }
    window.removeEventListener('storage', this.storageListener);
    if (this.accountSyncChannel) {
      try {
        this.accountSyncChannel.close();
      } catch (e) {}
      this.accountSyncChannel = null;
    }
  }

  onMenuClick(menu) {
    if (menu.title === 'Auto Planner') {
      const token = this.authService.getToken('token');
      const url = `${urls.PLANNER_BASE_URL}portal_oauth?token=JWT ${token}&env=${urls.IS_PROD ? 'live' : 'dev'}&base_url=${urls.SERVER_URL}api`;
      window.open(url, '_blank');
    }
  }

  toggleFullscreen() {
    if (!document.fullscreenElement) {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen().catch(err => console.log('Error attempting to enable fullscreen:', err));
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }

  get isMultipleProfile(): boolean {
    if (!this.user) return false;
    if (this.user.hasOwnProperty('isMultipleProfile')) {
      return !!this.user.isMultipleProfile;
    }
    if (this.user.company && this.user.company.hasOwnProperty('isMultipleProfile')) {
      return !!this.user.company.isMultipleProfile;
    }
    return false;
  }

  buildProfileCompanies() {
    if (!this.isMultipleProfile) {
      this.profileCompanies = [];
      return;
    }

    const currentCompanyEntry = {
      id: this.user ? (this.user._id || this.user.id || 'current') : 'current',
      name: this.user && this.user.displayName ? this.user.displayName : 'Current Company',
      email: this.user && this.user.email ? this.user.email : '',
      logoURL: this.user ? (this.user.profileImageURL || this.user.profileImage) : null,
      isCurrent: true
    };
    this.profileCompanies = [currentCompanyEntry];

    this.companiesService
      .getAccountLinks()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        data => {
          const rawList = Array.isArray(data) ? data : (data && data.accountlinks ? data.accountlinks : []);
          const currentEmail = (this.user && this.user.email ? this.user.email.toLowerCase() : '').trim();
          const currentId = this.user ? (this.user._id || this.user.id || this.user.companyId) : null;

          let hasCurrent = false;
          const mappedAccounts = (rawList || []).map(item => {
            const comp = (item.refCompany && typeof item.refCompany === 'object') ? item.refCompany : {};
            const name = item.name || comp.displayName || comp.name || item.email || 'Company';
            const email = item.email || comp.email || '';
            const logoURL = item.profileImageURL || item.profileImage || item.logoURL || comp.profileImageURL || comp.profileImage || comp.logoURL || null;
            const id = item.id || item._id || (comp && (comp._id || comp.id)) || item.refCompany || item.refUser;
            const accountLinkId = item._id || item.id;

            const isCurrent = (!!currentEmail && !!email && email.toLowerCase() === currentEmail) ||
                              (!!currentId && (id === currentId || item.refUser === currentId || item.refCompany === currentId || item._id === currentId));
            if (isCurrent) {
              hasCurrent = true;
            }
            return {
              ...item,
              id: id,
              accountLinkId: accountLinkId,
              name: name,
              email: email,
              logoURL: logoURL,
              isCurrent: isCurrent
            };
          });

          if (mappedAccounts.length > 0) {
            if (!hasCurrent) {
              this.profileCompanies = [currentCompanyEntry, ...mappedAccounts];
            } else {
              this.profileCompanies = mappedAccounts;
            }
          }
        },
        () => {
          // Keep just the current company entry if the linked-accounts list fails to load.
        }
      );
  }

  getCompanyInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    const initials = parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0].substring(0, 2);
    return initials.toUpperCase();
  }

  selectProfileCompany(company) {
    if (company.isCurrent || this.switchingProfileId) return;
    this.switchingProfileId = company.id || company.accountLinkId;
    this.switchToCompany(company);
  }

  removeAccountLink(event: MouseEvent, company: any) {
    event.stopPropagation();
    if (company.isCurrent || this.deletingAccountLinkId || !company.accountLinkId) return;

    if (!confirm(`Are you sure you want to unlink ${company.name || 'this account'}?`)) {
      return;
    }

    this.deletingAccountLinkId = company.accountLinkId;
    this.companiesService
      .deleteAccountLink(company.accountLinkId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (res: any) => {
          this.deletingAccountLinkId = null;
          this.toastr.success(res && res.message ? res.message : 'Account unlinked successfully', 'Success');
          this.buildProfileCompanies();
          this.broadcastSyncEvent('ACCOUNT_LINKS_UPDATED');
        },
        error => {
          this.deletingAccountLinkId = null;
          this.toastr.error(error && error.message ? error.message : 'Failed to unlink account', 'Error');
        }
      );
  }

  openAddCompanyModal() {
    this.showUserOptions = false;
    this.showAddCompanyModal = true;
  }

  onCompanyAdded(result?: any) {
    this.buildProfileCompanies();
    this.broadcastSyncEvent('ACCOUNT_LINKS_UPDATED');
  }

  private switchToCompany(company) {
    const payload = {
      type: company.refType || company.type || (company.mainType ? company.mainType : 'Company'),
      accountLinkId: company.accountLinkId || company._id || company.id
    };

    this.companiesService
      .signInAccountLink(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        data => {
          if (data && data.success) {
            if (data.user && data.user.hasOwnProperty('isForceLogout') && data.user.isForceLogout) {
              this.switchingProfileId = null;
              this.toastr.warning('Account is locked or force logged out.', 'Warning');
              return;
            }

            // 1. Perform complete logout cleanup from old session
            this.socket.disconnectSocket();
            this.authService.removeToken();
            this.authService.removeAuthToken();
            this.sharedDataService.saveUser(null);
            this.sharedDataService.saveSubMenus(null);
            localStorage.removeItem('notificationsCount');
            localStorage.removeItem('messageCount');

            // 2. Perform complete login setup for new session (matching normal Sign In)
            this.authService.setToken(data.token);
            if (data.user && data.user.authToken) {
              this.authService.setAuthToken(data.user.authToken);
            }
            this.sharedDataService.saveUser(data.user);
            if (data.user && (data.user.timeZone || (data.user.company && data.user.company.timeZone))) {
              moment.tz.setDefault(data.user.company && data.user.company.timeZone ? data.user.company.timeZone : data.user.timeZone);
            }
            this.socket.connectSocket();

            // 3. Broadcast to all other open tabs/windows across browsers
            this.broadcastSyncEvent('ACCOUNT_SWITCHED');

            this.toastr.success(data.message || 'Switched account successfully', 'Success');
            setTimeout(() => {
              window.location.href = '/';
            }, 300);
          } else {
            this.switchingProfileId = null;
            this.toastr.error(data && data.message ? data.message : 'Failed to switch account', 'Error');
          }
        },
        error => {
          this.switchingProfileId = null;
          this.toastr.error(error && error.message ? error.message : 'Failed to switch account', 'Error');
        }
      );
  }
}
